export default __webpack_public_path__ + "static/media/vectuel_logo.9e64931a.png";